import { render, staticRenderFns } from "./ProductComprehensiveAnalysis.vue?vue&type=template&id=3c236f13&scoped=true"
import script from "./ProductComprehensiveAnalysis.vue?vue&type=script&lang=js"
export * from "./ProductComprehensiveAnalysis.vue?vue&type=script&lang=js"
import style1 from "./ProductComprehensiveAnalysis.vue?vue&type=style&index=1&id=3c236f13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c236f13",
  null
  
)

export default component.exports